module.exports = __webpack_public_path__ + "static/media/productImg.83591b2b.jpg";